type LegacyGpoPageProps = {
  locale?: "en" | "pt";
};

export function LegacyGpoPage({ locale = "en" }: LegacyGpoPageProps) {
  const isPortuguese = locale === "pt";

  return (
    <div className="mx-auto max-w-3xl space-y-4 px-4 py-8 md:py-12">
      <h1 className="text-balance text-3xl font-bold tracking-tight text-foreground">
        GPO (Legacy)
      </h1>
      <p className="text-lg text-muted-foreground">
        {isPortuguese
          ? "A documentação do fluxo de pagamento GPO legacy será adicionada aqui juntamente com a referência OpenAPI quando estiver pronta."
          : "Documentation for the legacy GPO payment flow will be added here alongside the OpenAPI reference when it is ready."}
      </p>
    </div>
  );
}
